<template>
  <div class="container col-md-12">
    <h1>Social Security calculator</h1>
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>

    <div v-if="calcData">
      <hr />
      <h3>Result</h3>
      <md-content>
        <md-tabs md-dynamic-height md-border-bottom>
          <md-tab md-label="Retirement Dates">
            <md-content class="md-padding">
              <table class="table table-striped table-bordered">
                <tr>
                  <th>Born on January 1?</th>
                  <td>
                    {{ calcData.retirement_dates.birth_day_first_year_day }}
                  </td>
                </tr>
                <tr>
                  <th>Born on first of month?</th>
                  <td>
                    {{ calcData.retirement_dates.birth_day_first_month_day }}
                  </td>
                </tr>
                <tr>
                  <th>NRA - Years</th>
                  <td>{{ calcData.retirement_dates.nra_years }}</td>
                </tr>
                <tr>
                  <th>NRA - Months</th>
                  <td>{{ calcData.retirement_dates.nra_months }}</td>
                </tr>
                <tr>
                  <th>NRD Month</th>
                  <td>{{ calcData.retirement_dates.nrd_month }}</td>
                </tr>
                <tr>
                  <th>NRD Year</th>
                  <td>{{ calcData.retirement_dates.nrd_year }}</td>
                </tr>
                <tr>
                  <th>Normal Retirement Date (NRD)</th>
                  <td>
                    {{ calcData.retirement_dates.nrd | date("MM/D/YYYY") }}
                  </td>
                </tr>
                <tr>
                  <th>NRD in months</th>
                  <td>{{ calcData.retirement_dates.nrd_in_months }}</td>
                </tr>
                <tr>
                  <th>Age 62 Date of Birth</th>
                  <td>
                    {{
                      calcData.retirement_dates.age62_birth_date
                        | date("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Age 62 first YOE</th>
                  <td>{{ calcData.retirement_dates.age62_first_yoe }}</td>
                </tr>
                <tr>
                  <th>Age 62 first MOE</th>
                  <td>{{ calcData.retirement_dates.age62_first_moe }}</td>
                </tr>
                <tr>
                  <th>Age 62 Retirement Date</th>
                  <td>
                    {{
                      calcData.retirement_dates.age62_date | date("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Age 62 Retirement Date Months</th>
                  <td>{{ calcData.retirement_dates.age62_in_months }}</td>
                </tr>
                <tr>
                  <th>Age 62 Max Reduction Factor</th>
                  <td>
                    {{ calcData.retirement_dates.age62_max_reduction_factor }}
                  </td>
                </tr>
                <tr>
                  <th>Age 70 months from NRD</th>
                  <td>{{ calcData.retirement_dates.age70_nrd_months }}</td>
                </tr>
                <tr>
                  <th>Age 70 Retirement Date Year</th>
                  <td>{{ calcData.retirement_dates.age70_nrd_year }}</td>
                </tr>
                <tr>
                  <th>Age 70 Retirement Date Months</th>
                  <td>{{ calcData.retirement_dates.age70_nrd_month }}</td>
                </tr>
                <tr>
                  <th>Age 70 Retirement Date</th>
                  <td>
                    {{
                      calcData.retirement_dates.age70_date | date("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Age 70 Retirement Date Months</th>
                  <td>{{ calcData.retirement_dates.age70_in_months }}</td>
                </tr>
                <tr>
                  <th>Desired Retirement Date (DRD)</th>
                  <td>
                    {{ calcData.retirement_dates.drd | date("MM/D/YYYY") }}
                  </td>
                </tr>
                <tr>
                  <th>DRD in months</th>
                  <td>{{ calcData.retirement_dates.drd_in_months }}</td>
                </tr>
                <tr>
                  <th>DRD January 1?</th>
                  <td>{{ calcData.retirement_dates.drd_first_year_day }}</td>
                </tr>
                <tr>
                  <td
                    colspan="4"
                    scope="colgroup"
                    style="background-color: black; color:white"
                  >
                    Calculate beginning Comp Factors
                  </td>
                </tr>
                <tr>
                  <th>2018 Compensation</th>
                  <td>
                    {{
                      calcData.participant.estimated_annual_wages
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Year Worker attains age 60</th>
                  <td>
                    {{ calcData.compensation_factors.age60_attains_year }}
                  </td>
                </tr>
                <tr>
                  <th>Avg Wage at age 60</th>
                  <td>
                    {{
                      calcData.compensation_factors.age60_avg_wage
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
              </table>
            </md-content>
          </md-tab>
          <md-tab md-label="Indexed wages">
            <md-content class="md-padding">
              <table class="table table-striped table-bordered">
                <tr>
                  <th>Year</th>
                  <th>Wages</th>
                  <th>Rounded</th>
                  <th>MTWB</th>
                  <th>Lesser of</th>
                  <th>Index</th>
                  <th>AIME</th>
                </tr>
                <tr v-for="row in calcData.indexed_wages.rows">
                  <td>{{ row.year }}</td>
                  <td>{{ row.wages | currency({ fractionCount: 0 }) }}</td>
                  <td>
                    {{ row.rounded_wages | currency({ fractionCount: 0 }) }}
                  </td>
                  <td>{{ row.mtwb | currency({ fractionCount: 0 }) }}</td>
                  <td>{{ row.lesser_of | currency({ fractionCount: 0 }) }}</td>
                  <td>{{ row.ratio | numeral("0.4") }}</td>
                  <td>{{ row.aime | currency }}</td>
                  <td>{{ row.avg_aime | currency }}</td>
                </tr>
              </table>
            </md-content>
          </md-tab>
          <md-tab md-label="Indexed Monthly Wages">
            <md-content class="md-padding">
              <table class="table table-striped table-bordered">
                <tr>
                  <th>
                    Calculate Indexed Monthly Wages @62 (could be age 61 and 1
                    month)
                  </th>
                  <td>
                    {{
                      calcData.indexed_monthly_wages.at_62
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Calculate Indexed Monthly Wages @NRD</th>
                  <td>
                    {{
                      calcData.indexed_monthly_wages.at_nrd
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Calculate Indexed Monthly Wages @70</th>
                  <td>
                    {{
                      calcData.indexed_monthly_wages.at_70
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Calculate Indexed Monthly Wages @DRD</th>
                  <td>
                    {{
                      calcData.indexed_monthly_wages.at_drd
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
              </table>
            </md-content>
          </md-tab>
          <md-tab md-label="Benefit @ Bend Points">
            <md-content class="md-padding">
              <table class="table table-striped table-bordered">
                <tr>
                  <th></th>
                  <th>90%</th>
                  <th>32%</th>
                  <th>15%</th>
                  <th>Sum</th>
                </tr>
                <tr>
                  <td>Obtain Bend Points for year reach age 62</td>
                  <td>
                    {{
                      calcData.bend_points_benefit.reach_age62.percent90
                        | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.reach_age62.percent32
                        | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.reach_age62.percent15
                        | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="5"
                    scope="colgroup"
                    style="background-color: black; color:white"
                  >
                    Calculate Benefit @ Bend Points
                  </td>
                </tr>
                <tr>
                  <td>Age 62 (possibly plus 1 mo)</td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_62.percent90 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_62.percent32 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_62.percent15 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_62.sum
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Normal Retirement Date</td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_nrd.percent90 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_nrd.percent32 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_nrd.percent15 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_nrd.sum
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Age 70</td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_70.percent90 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_70.percent32 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_70.percent15 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_70.sum
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Desired Retirement Date</td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_drd.percent90 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_drd.percent32 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_drd.percent15 | currency
                    }}
                  </td>
                  <td>
                    {{
                      calcData.bend_points_benefit.at_drd.sum
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
              </table>
            </md-content>
          </md-tab>
          <md-tab md-label="Adjustments">
            <md-content class="md-padding">
              <table class="table table-striped table-bordered">
                <tr>
                  <td
                    colspan="2"
                    scope="colgroup"
                    style="background-color: black; color:white"
                  >
                    Adjustments for Early/Late Retirement
                  </td>
                </tr>
                <tr>
                  <th>Age 62 (possibly plus 1 mo)</th>
                  <td>
                    {{
                      calcData.adjustments_retirement.early
                        | numeral("0.[000]")
                    }}%
                  </td>
                </tr>
                <tr>
                  <th>Normal Retirement Date</th>
                  <td>
                    {{
                      calcData.adjustments_retirement.normal | numeral("0.00")
                    }}%
                  </td>
                </tr>
                <tr>
                  <th>Age 70</th>
                  <td>
                    {{
                      calcData.adjustments_retirement.late | numeral("0.00")
                    }}%
                  </td>
                </tr>
                <tr>
                  <th>Monthly Early Retirement Factor</th>
                  <td>
                    {{
                      calcData.adjustments_retirement.early_monthly
                        | numeral("0.000")
                    }}%
                  </td>
                </tr>
                <tr>
                  <th>Monthly Late Retirement Factor</th>
                  <td>
                    {{
                      calcData.adjustments_retirement.late_monthly
                        | numeral("0.000")
                    }}%
                  </td>
                </tr>
                <tr>
                  <th>Desired Retirement Date</th>
                  <td>
                    {{ calcData.adjustments_retirement.drd | numeral("0.00") }}%
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="2"
                    scope="colgroup"
                    style="background-color: black; color:white"
                  >
                    Adjustments for COLA
                  </td>
                </tr>
                <tr>
                  <th>Age 62 year</th>
                  <td>{{ calcData.adjustments_retirement.cola_age62_year }}</td>
                </tr>
                <tr>
                  <th>COLA</th>
                  <td>
                    {{ calcData.adjustments_retirement.cola | numeral("0.2") }}%
                  </td>
                </tr>
              </table>
            </md-content>
          </md-tab>
          <md-tab md-label="Benefits">
            <md-content class="md-padding">
              <table class="table table-striped table-bordered">
                <tr>
                  <td
                    colspan="2"
                    scope="colgroup"
                    style="background-color: black; color:white"
                  >
                    Benefits at Various Retirement Dates
                  </td>
                </tr>
                <tr>
                  <th>Age 62 (possibly plus 1 mo)</th>
                  <td>
                    {{
                      calcData.benefit_retirements.age62
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Normal Retirement Date</th>
                  <td>
                    {{
                      calcData.benefit_retirements.nrd
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Age 70</th>
                  <td>
                    {{
                      calcData.benefit_retirements.age70
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Desired Retirement Date</th>
                  <td>
                    {{
                      calcData.benefit_retirements.drd
                        | currency({ fractionCount: 0 })
                    }}
                  </td>
                </tr>
              </table>
            </md-content>
          </md-tab>
        </md-tabs>
      </md-content>
    </div>
  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>
<script>
import RoeCalcInputFields from "@/components/calculators/InputFields";
import store from "@/store";
import { mapGetters } from "vuex";
import { CALC_SOCIAL_SECURITY, CALC_RESET_STATE } from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
export default {
  data() {
    return {
      calcAction: CALC_SOCIAL_SECURITY,
      inputCategories: [INPUT_TYPES.PARTICIPANT, INPUT_TYPES.PLAN_BASIC_DATA]
    };
  },
  components: { RoeCalcInputFields },
  computed: {
    ...mapGetters(["calcData"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
